export const BLOG = {
  "impianto-cocleare-come-funziona": {
    title: "Impianto cocleare: come funziona e a chi è indicato",
    date: "2026",
    tag: "Impianto Cocleare",
    img: "/assets/impianto.jpg",
    intro:
      "L'impianto cocleare è un dispositivo medico che può restituire la percezione dei suoni a chi convive con una sordità grave o profonda. Capire come funziona e quando è indicato aiuta a fare scelte consapevoli, insieme agli specialisti.",
    sections: [
      {
        h: "Che cos'è e come funziona",
        p: [
          "A differenza della protesi acustica, che amplifica i suoni, l'impianto cocleare bypassa le cellule danneggiate dell'orecchio interno e stimola direttamente il nervo acustico.",
          "È composto da una parte esterna (processore del suono) e da una parte interna, impiantata chirurgicamente. Il processore capta i suoni, li elabora e li invia agli elettrodi che stimolano la coclea.",
        ],
      },
      {
        h: "A chi è indicato",
        p: [
          "L'impianto cocleare è indicato quando le protesi acustiche tradizionali non garantiscono più un beneficio sufficiente, sia nei bambini sia negli adulti.",
          "La valutazione è sempre multidisciplinare: otorino, audiologo, logopedista e psicologo definiscono insieme l'idoneità e il percorso più adatto.",
        ],
      },
      {
        h: "Dopo l'intervento: la riabilitazione",
        p: [
          "L'impianto non è un punto di arrivo, ma l'inizio di un percorso. La riabilitazione logopedica è fondamentale per imparare (o reimparare) a interpretare i suoni.",
          "Il supporto della famiglia e di una rete di persone che hanno vissuto la stessa esperienza fa una grande differenza: è qui che l'associazione può aiutarti.",
        ],
      },
    ],
  },

  "vivere-con-impianto-cocleare-consigli": {
    title: "Vivere con l'impianto cocleare: consigli pratici quotidiani",
    date: "2026",
    tag: "Impianto Cocleare",
    img: "/assets/paziente.jpg",
    intro:
      "Convivere con un impianto cocleare significa anche prendersi cura del dispositivo e adottare qualche accorgimento nella vita di tutti i giorni. Ecco alcuni consigli pratici raccolti dall'esperienza di chi lo usa ogni giorno.",
    sections: [
      {
        h: "Cura del processore",
        p: [
          "Mantieni il processore asciutto e pulito: l'umidità è uno dei principali nemici. Utilizza gli appositi kit di asciugatura, soprattutto in estate o dopo l'attività fisica.",
          "Tieni sempre con te batterie di scorta e i piccoli accessori di ricambio.",
        ],
      },
      {
        h: "Ambienti rumorosi e telefonate",
        p: [
          "Negli ambienti affollati, posizionati in modo da vedere il volto di chi parla e sfrutta i programmi del processore dedicati al rumore.",
          "Molti dispositivi si collegano in streaming a smartphone e TV: una funzione preziosa per telefonate e contenuti multimediali.",
        ],
      },
      {
        h: "Sport, acqua e tempo libero",
        p: [
          "Esistono accessori specifici per proteggere il processore durante lo sport e soluzioni waterproof per il nuoto: informati sul modello che usi.",
        ],
      },
      {
        h: "Non sei solo",
        p: [
          "Confrontarsi con altre persone con impianto cocleare aiuta a risolvere dubbi pratici e a vivere il dispositivo con serenità. Contattaci per entrare in contatto con la nostra rete.",
        ],
      },
    ],
  },

  "manutenzione-impianto-cocleare-protesi": {
    title: "Manutenzione di impianti e protesi: la guida essenziale",
    date: "2026",
    tag: "Manutenzione",
    img: "/assets/protesi.jpg",
    intro:
      "Una buona manutenzione allunga la vita dei dispositivi uditivi e ne preserva le prestazioni. Bastano poche abitudini quotidiane per evitare guasti e malfunzionamenti.",
    sections: [
      {
        h: "Pulizia quotidiana",
        p: [
          "Pulisci ogni giorno la protesi o il processore con un panno morbido e asciutto. Evita acqua, alcol e detergenti aggressivi.",
          "Controlla e libera le aperture dal cerume e dai residui, usando gli strumenti forniti dal tuo audioprotesista.",
        ],
      },
      {
        h: "Batterie e umidità",
        p: [
          "Spegni i dispositivi quando non li usi e apri il vano batteria durante la notte per favorire l'asciugatura.",
          "Conserva i dispositivi in un contenitore con deumidificatore, soprattutto nei mesi più caldi e umidi.",
        ],
      },
      {
        h: "Controlli periodici e riparazioni",
        p: [
          "Programma controlli regolari presso il centro di riferimento. Per problemi tecnici, sostituzioni e aggiornamenti rivolgiti al produttore o al servizio sanitario.",
          "Verifica le condizioni di garanzia e le eventuali coperture assicurative: l'associazione può aiutarti a orientarti tra le pratiche.",
        ],
      },
    ],
  },

  "ipoacusia-infantile-primi-segnali": {
    title: "Ipoacusia infantile: riconoscere i primi segnali",
    date: "2026",
    tag: "Ipoacusia",
    img: "/assets/prove-udito.jpg",
    intro:
      "Individuare precocemente un problema uditivo in un bambino è decisivo per lo sviluppo del linguaggio e per l'inclusione. Ecco i segnali a cui prestare attenzione e cosa fare.",
    sections: [
      {
        h: "I campanelli d'allarme",
        p: [
          "Nei primi mesi: il bambino non reagisce a rumori forti, non si gira verso la fonte del suono, non si calma alla voce dei genitori.",
          "Più avanti: ritardo nella comparsa delle prime parole, necessità di alzare il volume, difficoltà a comprendere in ambienti rumorosi.",
        ],
      },
      {
        h: "Lo screening neonatale",
        p: [
          "In Italia lo screening uditivo neonatale permette di individuare precocemente molte forme di ipoacusia. È un esame semplice e non invasivo.",
          "Se lo screening evidenzia qualcosa, è importante non allarmarsi ma procedere subito con gli approfondimenti audiologici.",
        ],
      },
      {
        h: "Cosa fare dopo la diagnosi",
        p: [
          "Una diagnosi precoce consente di avviare per tempo protesizzazione e riabilitazione, con risultati spesso molto positivi.",
          "Le famiglie hanno bisogno di informazioni chiare e di sostegno: A.S.I. Sicilia ETS affianca i genitori in ogni fase del percorso.",
        ],
      },
    ],
  },

  "supporto-disabilita-uditiva-sicilia": {
    title: "Come ottenere supporto per la disabilità uditiva in Sicilia",
    date: "2026",
    tag: "Guida",
    img: "/assets/audioprotesista.jpg",
    intro:
      "Affrontare una difficoltà uditiva — propria o di un figlio — può sembrare un percorso complicato. In questa guida riassumiamo i primi passi pratici per orientarsi in Sicilia, dalla diagnosi al riconoscimento dell'invalidità, fino al supporto delle associazioni di volontariato come A.S.I. Sicilia ETS.",
    sections: [
      {
        h: "1. La diagnosi: il punto di partenza",
        p: [
          "Tutto parte da una valutazione audiologica presso un centro di Otorinolaringoiatria. In Sicilia puoi rivolgerti alle strutture pubbliche, tra cui le U.O.C. di Otorinolaringoiatria delle Aziende Ospedaliere Universitarie.",
          "Una diagnosi precoce è fondamentale, soprattutto nei bambini: prima si interviene, migliori sono le possibilità di sviluppo del linguaggio e di inclusione.",
        ],
      },
      {
        h: "2. Protesi acustiche e impianto cocleare",
        p: [
          "In base al tipo e al grado di ipoacusia, lo specialista può indicare protesi acustiche o, nei casi più severi, un impianto cocleare.",
          "Il Servizio Sanitario può coprire o contribuire ai dispositivi: è importante farsi seguire nelle pratiche, nei controlli e nella manutenzione. Su questo l'associazione offre assistenza concreta ai propri soci.",
        ],
      },
      {
        h: "3. Invalidità civile e diritti",
        p: [
          "Il riconoscimento dell'invalidità civile e dello stato di handicap (Legge 104/1992) apre l'accesso a una serie di tutele: agevolazioni, supporti scolastici e lavorativi.",
          "La domanda si presenta tramite il medico curante e l'INPS. Un'associazione può aiutarti a capire i passaggi ed evitare errori che allungano i tempi.",
        ],
      },
      {
        h: "4. Il ruolo delle associazioni di volontariato",
        p: [
          "Non sei solo. A.S.I. Sicilia ETS affianca persone e famiglie passo dopo passo: ascolto, informazione, supporto tecnico sui dispositivi e orientamento ai servizi del territorio.",
        ],
      },
    ],
  },

  "diritti-persone-sorde-guida-pratica": {
    title: "Diritti delle persone sorde: guida pratica 2026",
    date: "2026",
    tag: "Diritti",
    img: "/assets/orecchio.jpg",
    intro:
      "Conoscere i propri diritti è il primo passo per farli valere. Ecco una panoramica pratica dei principali diritti delle persone con disabilità uditiva in ambito scolastico, lavorativo e sanitario.",
    sections: [
      {
        h: "Scuola e diritto allo studio",
        p: [
          "I bambini e i ragazzi con disabilità uditiva hanno diritto all'inclusione nella scuola pubblica, con un Piano Educativo Individualizzato (PEI) e, ove necessario, supporti tecnici e figure di sostegno.",
          "È un diritto, non una concessione: l'associazione aiuta le famiglie a richiedere e ottenere gli strumenti adeguati.",
        ],
      },
      {
        h: "Lavoro e pari opportunità",
        p: [
          "Le persone con ipoacusia hanno diritto a un inserimento lavorativo in condizioni di pari opportunità, anche attraverso il collocamento mirato (Legge 68/1999).",
          "I datori di lavoro possono prevedere accomodamenti ragionevoli per garantire piena partecipazione.",
        ],
      },
      {
        h: "Sanità e accesso ai dispositivi",
        p: [
          "Diagnosi, protesizzazione e riabilitazione rientrano tra le prestazioni a cui si può accedere tramite il Servizio Sanitario, secondo i percorsi previsti.",
          "Conoscere tempi e modalità evita ritardi: l'associazione fornisce informazioni aggiornate e supporto nelle pratiche.",
        ],
      },
    ],
  },

  "bonus-agevolazioni-2026-ipoacusia": {
    title: "Bonus e agevolazioni 2026 per ipoacusia e sordità",
    date: "2026",
    tag: "Agevolazioni",
    img: "/assets/cabina.jpg",
    intro:
      "Esistono diverse agevolazioni fiscali ed economiche dedicate alle persone con disabilità uditiva e alle loro famiglie. Ecco cosa è utile sapere per non perdere opportunità. (Verifica sempre i requisiti aggiornati presso gli enti competenti.)",
    sections: [
      {
        h: "Detrazioni e spese sanitarie",
        p: [
          "Le spese per protesi acustiche e dispositivi medici possono dare diritto a detrazioni o deduzioni nella dichiarazione dei redditi, nei limiti previsti dalla normativa vigente.",
          "Conserva sempre fatture e documentazione: sono indispensabili per ottenere i benefici.",
        ],
      },
      {
        h: "Contributi per dispositivi",
        p: [
          "In presenza di invalidità riconosciuta, è possibile accedere a contributi o alla fornitura di dispositivi tramite il Servizio Sanitario, secondo i percorsi regionali.",
        ],
      },
      {
        h: "Agevolazioni legate alla Legge 104",
        p: [
          "Il riconoscimento dello stato di handicap può dare accesso a permessi lavorativi, agevolazioni fiscali e altre tutele per la persona e per i familiari che prestano assistenza.",
        ],
      },
      {
        h: "Hai bisogno di aiuto a orientarti?",
        p: [
          "Le agevolazioni cambiano e i requisiti vanno verificati caso per caso. Contatta A.S.I. Sicilia ETS: ti aiutiamo a capire cosa ti spetta e come richiederlo.",
        ],
      },
    ],
  },
};
